import Actions from 'actions';

const initialState = Object.freeze({});

function signIn(state = initialState, action) {
  switch (action.type) {
    case Actions.SIGN_IN_REQUEST:
      return initialState;
    case Actions.SIGN_IN_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.SIGN_IN_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default signIn;
